import "./styles.scss"
import {
  FormRow,
  Input,
  Label,
  SelectInput,
} from "../../components/Form"

const CodesValuesScreenFixed = ({
  codesValues,
  values,
  handleChangeCodes,
  filterQuestionsByCode,
  resetFields,
}) => {

  return (
    <div>
      <div className="codes-fields">
        {codesValues?.map((el, index) => (
          <FormRow key={index + 1}>
            <div>
              <div className={`${el?.type?.includes("select") ? "select-form" : ""}`}>
                <div className="form-date questions-name">
                  <Label label={`${el?.name}`} />
                </div>
                <div className="form-date values-fields">
                  {el?.id === undefined && (
                    <Input
                      name="value"
                      value={el?.value || ""}
                      onChange={(e) => handleChangeCodes(index, e, el?.name)}
                    />
                  )}
                  {el?.id !== undefined && el.type === "select" && (
                    <SelectInput
                      name="codes"
                      resetFields={resetFields}
                      onChange={(field, e) => handleChangeCodes(field, e, el?.id)}
                      isSearchable={true}
                      options={filterQuestionsByCode[0][el?.id]}
                      defaultValue={values
                        ?.filter((item) => item.code === el?.id)
                        .map(({ code, value, label }) => ({ label, value }))}
                      isOverModal={true}
                      isMulti={el?.isMulti}
                      menuShouldBlockScroll={true}
                    />
                  )}
                </div>
              </div>
            </div>
          </FormRow>
        ))}
      </div>
    </div>
  )
}

export default CodesValuesScreenFixed
